import styled from 'styled-components/macro';

const OpenButton = styled.button`
  position: absolute;
  left: 255px;
  display: flex;
  height: 35px;
  padding: 0;
  color: #fff;
  opacity: 0.6;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  transition: opacity 0.3s, left 0.3s;
  ${props => props.isSearchFormOpen && `
    left: 15px;
    cursor: default;
    outline: none;
  `}

  &:hover {
    opacity: 0.8;
  }
`;

export default OpenButton;
